import { format } from 'date-fns';
import { ar } from 'date-fns/locale';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import ka from 'date-fns/locale/ka';

import { IWorkingDay } from '@/modules/workingDay/types';

export const getCardData = (
  jobInstance: IWorkingDay.IJobInstance,
  language: string
) => {
  const locale =
    language === 'ar'
      ? ar
      : language === 'es'
      ? es
      : language === 'ka'
      ? ka
      : language === 'fr'
      ? fr
      : en;

  return {
    jobName: jobInstance.jobName,
    jobInstanceId: `#${jobInstance.jobInstanceId || '-'}`,
    yardNumber: `#${jobInstance.name}`,
    startTime: jobInstance.startTime
      ? format(new Date(jobInstance.startTime), 'hh:mm a', {
          locale,
        })
      : '-',
    // only endTime show when status ended
    endTime:
      jobInstance.jobInstanceStatus === 0 && jobInstance.endTime
        ? format(new Date(jobInstance.endTime), 'hh:mm a', {
            locale,
          })
        : '-',
    supervisorName: jobInstance.supervisorName,
    attendance: jobInstance.attendance,
    target: `${jobInstance.target} ${jobInstance.productivityMeasurementUnit}`,
    productivity: `${jobInstance.productivity} %`,
    // cost: jobInstance.cost,
  };
};
